<template>
  <div class="search-drawer-buildings">
    <div class="form__container">
      <i-form class="form" :label-width="80">
        <i-form-item label="階建">
          <i-input v-model="search.floor" style="width: 80px;" placeholder clearable filterable size="small" />
          <span class="form__text">階以上</span>
        </i-form-item>
        <i-form-item label="建物面積">
          <i-input v-model="search.floor_area" style="width: 80px;" placeholder clearable filterable size="small" />
          <span class="form__text">㎡以上</span>
        </i-form-item>

        <i-form-item label="築年数">
          <i-select v-model="search.build_y_from" size="small" placeholder filterable clearable style="width: 80px;">
            <i-option v-for="item in year" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">年</span>
          <i-select v-model="search.build_m_from" size="small" placeholder filterable clearable style="width: 60px;">
            <i-option v-for="item in month" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">ヶ月</span>
          <span class="form__text">〜</span>
          <i-select v-model="search.build_y_to" size="small" placeholder filterable clearable style="width: 80px;">
            <i-option v-for="item in year" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">年</span>
          <i-select v-model="search.build_m_to" size="small" placeholder filterable clearable style="width: 60px;">
            <i-option v-for="item in month" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">ヶ月</span>
          <i-checkbox v-model="search.f_new_building" :true-value="1" :false-value="0" style="margin-left: 8px;">
            新築
          </i-checkbox>
        </i-form-item>

        <i-form-item label="建物設備">
          <template v-for="(item, idx) in buildingEquipments">
            <div :key="`buildingEquipments${idx}`" class="equipments">
              <span class="equipments__label">
                {{ item.name }}
              </span>
              <div class="equipments__checkboxs">
                <template v-for="(item, idx) in item.checkbox">
                  <i-checkbox :key="`checkbox${idx}`" v-model="search[item.value]" :true-value="1" :false-value="0">
                    {{ item.label }}
                  </i-checkbox>
                </template>
              </div>
            </div>
          </template>
        </i-form-item>
      </i-form>
    </div>
  </div>
</template>

<script>
import { Input, Form, FormItem, Select, Option, Checkbox } from 'view-design'
import BuildingEquipments from '@/constants/building_equipments'
export default {
  components: {
    'i-input': Input,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-select': Select,
    'i-option': Option,
    'i-checkbox': Checkbox,
  },
  data() {
    return {
      year: [],
      month: [],
      buildingEquipments: BuildingEquipments,
    }
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    master() {
      return this.$store.getters['Master/getMaster']
    },
  },
  created() {
    // Option用 日付
    for (let i = 0; i <= 100; i++) this.year.push(i)
    for (let i = 0; i <= 11; i++) this.month.push(i)
  },
}
</script>

<style lang="scss" scoped>
.search-drawer-buildings {
  .form {
    &__container {
      height: calc(100vh - 280px);
      overflow: scroll;
    }
    &__text {
      display: inline-block;
      margin: 0 8px;
    }
  }
  .equipments {
    display: flex;
    align-items: flex-start;
    &__label {
      display: inline-block;
      width: 80px;
      font-weight: bold;
    }
    &__checkboxs {
      display: inline-block;
      flex: 1;
    }
  }
}
</style>
